import PropTypes from "prop-types";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { subscribeToNewsletter } from "../../services/newsletter";
import { Button, TextInput, Typography, useDomId } from "../../themeV2";
import { planNewsletterSignup, signupStatus } from "./newsletterSignup";
import css from "./NewsletterSignup.module.css";

export default function NewsletterSignup({ className }) {
  const { pathname } = useLocation();
  const headingId = useDomId("newsletter");
  const [email, setEmail] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const editEmail = (value) => {
    setStatus("");
    setEmail(value);
  };

  const submit = async (event) => {
    event.preventDefault();
    const plan = planNewsletterSignup({ email, pathname });
    if (plan.rejection) return setStatus(plan.rejection);

    setIsSubmitting(true);
    const result = await subscribeToNewsletter(plan.request);
    setIsSubmitting(false);
    setStatus(signupStatus(plan.request, result));
    if (result.ok) setEmail("");
  };

  return (
    <section aria-labelledby={headingId} className={className}>
      <Typography id={headingId} as="h3" variant="title-lg">
        Sign up for our newsletter
      </Typography>
      <Typography color="variant" variant="body-md">
        Be the first in line for limited editions, promotions and new talent.
      </Typography>

      <form className={css.form} onSubmit={submit}>
        <TextInput
          className={css.field}
          variant="filled"
          type="email"
          label="Email address"
          autoComplete="email"
          required
          value={email}
          onValueChange={editEmail}
        />
        <Button type="submit" loading={isSubmitting}>
          Submit
        </Button>
      </form>

      <Typography role="status" as="p" variant="body-sm" className={css.status}>
        {status}
      </Typography>
    </section>
  );
}

NewsletterSignup.propTypes = {
  className: PropTypes.string,
};
